import { Button } from '@cma/common'
import { StarRisingIcon } from '@cma/icons'
import { HelixIcon } from '@helix/helix-icon'
import { plus_small as PlusSmallIcon } from '@helix/helix-icon/outlined'
import { useBrandHub } from './BrandHubContext'

interface AdminBrandEmptyStateProps {
  onAddBrand?: () => void
}

export default function AdminBrandEmptyState({
  onAddBrand
}: AdminBrandEmptyStateProps) {
  const { setShowAddBrandForm, hasOfficePermissionForSelected } = useBrandHub()

  const handleAddBrand = () => {
    if (onAddBrand) {
      onAddBrand()
    } else {
      setShowAddBrandForm(true)
    }
  }

  return (
    <>
      <div className="mx-auto flex flex-1 flex-col items-center justify-center md:max-w-[407px]">
        <div className="mb-[16px] flex h-[56px] w-[56px] items-center justify-center rounded-full bg-brand-white">
          <StarRisingIcon className="text-brand-primary" />
        </div>
        <h2 className="helix-heading mb-1">Brands</h2>
        <p className="helix-body text-center text-gray-500">
          Add and manage brands across your organization.
          <br className="hidden md:block" /> Customize how the brands appear
          across Cloud CMA reports, giving your agents and their clients a
          cohesive experience.
        </p>
        <div className="mt-6 flex items-center gap-2">
          <Button
            variant="tertiary"
            disabled={!hasOfficePermissionForSelected}
            leftIcon={
              <HelixIcon
                icon={PlusSmallIcon}
                className="stroke-brand-primary"
              />
            }
            onClick={handleAddBrand}>
            Add brand
          </Button>
        </div>
      </div>
    </>
  )
}
